export const DEFAULT_CONTRACT_PERIOD = 5;
